import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { RefreshCw, CreditCard } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaymentsMade() {
  const { token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState([]);

  useEffect(() => { fetchPayments(); }, [token]);

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/purchases/payments`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) setPayments((await res.json()).payments || []);
    } catch (error) { console.error(error); }
    finally { setLoading(false); }
  };

  const formatCurrency = (amt) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(amt || 0);

  if (loading) return <div className="flex justify-center p-8"><RefreshCw className="h-6 w-6 animate-spin" /></div>;

  return (
    <Card className="mt-4">
      <CardHeader><CardTitle className="flex items-center gap-2"><CreditCard className="h-5 w-5" />Payments Made</CardTitle></CardHeader>
      <CardContent>
        <Table>
          <TableHeader><TableRow><TableHead>Payment #</TableHead><TableHead>Date</TableHead><TableHead>Vendor</TableHead><TableHead>Mode</TableHead><TableHead>Reference</TableHead><TableHead className="text-right">Amount</TableHead></TableRow></TableHeader>
          <TableBody>
            {payments.map((p) => (
              <TableRow key={p.payment_id}>
                <TableCell className="font-medium">{p.payment_number}</TableCell>
                <TableCell>{p.payment_date}</TableCell>
                <TableCell>{p.vendor_name}</TableCell>
                <TableCell><Badge variant="outline">{p.payment_mode?.replace('_', ' ')}</Badge></TableCell>
                <TableCell className="text-slate-500">{p.reference_number || '-'}</TableCell>
                <TableCell className="text-right font-medium text-red-600">{formatCurrency(p.amount)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {payments.length === 0 && <div className="text-center py-8 text-slate-500">No payments made</div>}
      </CardContent>
    </Card>
  );
}
